const Server02 = ({ size = 16, color = 'currentColor', className = '', strokeWidth = '1.5', ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...rest}
    >
      <path
        d="M14.3996 4.4C14.3996 5.72548 11.5342 6.8 7.99961 6.8C4.46499 6.8 1.59961 5.72548 1.59961 4.4M14.3996 4.4C14.3996 3.07452 11.5342 2 7.99961 2C4.46499 2 1.59961 3.07452 1.59961 4.4M14.3996 4.4V11.6C14.3996 12.9255 11.5342 14 7.99961 14C4.46499 14 1.59961 12.9255 1.59961 11.6V4.4M14.3996 8C14.3996 9.32548 11.5342 10.4 7.99961 10.4C4.46499 10.4 1.59961 9.32548 1.59961 8"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

export default Server02
